import { useNavigate } from "react-router-dom";

const Cards = ({ icon, title, path, bg }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${path}`);
  };

  return (
    <div onClick={handleClick} className="dashboard-icon-item text-center mb-4">
      <div className='p-2 rounded' style={{ backgroundColor: bg }}>
        <img src={icon} alt={title} className="dashboard-icon" />
      </div>
      <div className="icon-title mt-2">{title}</div>
    </div>
  );
};

export default Cards;
